import { ChainId, Currency, METIS, Token } from '@netswap/sdk'
import { isEnvChain } from 'utils'
import { METIS_TOKEN } from '../constants'

export function currencyId(currency: Currency, chainId: ChainId | undefined): string {
  if (currency === METIS) return isEnvChain(chainId) && chainId ? METIS_TOKEN : 'ETH'
  if (currency instanceof Token) return currency.address
  throw new Error('invalid currency')
}
